export default __webpack_public_path__ + "static/media/share.95a014c7.svg";